import React, { useContext, useState, useEffect } from 'react';
import { SketchPicker, AlphaPicker } from 'react-color';
import axios from 'axios';
import { API_URL } from '../../Config/constant';
import { LayoutContext } from '../../Context/LayoutContext';
import toast, { Toaster } from 'react-hot-toast';
import Loader from '../Common/Loader';

export default function Site() {
  const [settings, setSettings] = useState([
    { type: 'primaryColor', value: '#000000' },
    { type: 'secondaryColor', value: '#ffffff' },
    { type: 'headerColor', value: '#ffffff' },
    { type: 'fontFamily', value: '' },
  ]);
  const [loading, setLoading] = useState(false);
  const { apiToken } = useContext(LayoutContext);

  useEffect(() => {
    const fetchSettings = async () => {
      setLoading(true);
      try {
        const response = await axios.post(
          `${API_URL}api/settings`,
          {},
          {
            headers: {
              Authorization: `Bearer ${apiToken}`,
            },
          }
        );
        const { result } = response.data;
        if (Array.isArray(result)) {
          const updatedSettings = settings.map((setting) => {
            const fetchedSetting = result.find((item) => item.type === setting.type);
            return fetchedSetting ? { ...setting, value: fetchedSetting.value } : setting;
          });
          // console.log("Settings fetched:", updatedSettings);
          setSettings(updatedSettings);
        } else {
          console.error('Invalid settings data format:', response.data);
        }
      } catch (error) {
        console.error('Error fetching settings:', error);
      } finally {
        setLoading(false);
      }
    };
    if (apiToken) {
      fetchSettings();
    }
  }, [apiToken]);

  const handleColorChange = (type, color) => {
    setSettings((prevSettings) =>
      prevSettings.map((setting) =>
        setting.type === type ? { ...setting, value: color.hex } : setting
      )
    );
  };

  const handleInputChange = (type, value) => {
    setSettings((prevSettings) =>
      prevSettings.map((setting) => (setting.type === type ? { ...setting, value } : setting))
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post(`${API_URL}api/cms-settings`, settings, {
        headers: {
          Authorization: `Bearer ${apiToken}`,
          'Content-Type': 'application/json',
        },
      });
      // console.log("Settings saved:", response.data);
      toast.success('Settings saved successfully!');
    } catch (error) {
      console.error('Error saving settings:', error);
      toast.error('Failed to save settings.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card">
      <Toaster />
      {loading && <Loader />}
      <div className="card-header">
        <h2 className="card-title">Site Setting</h2>
      </div>
      <div className="form-creation">
        <div className="row">
          <div className="col-xl-3 col-sm-3 col-6">
            <div className="form-group">
              <label htmlFor="primaryColor">Primary Color</label>
              <div style={{ overflow: 'auto' }}>
                <SketchPicker
                  color={settings.find((s) => s.type === 'primaryColor')?.value || '#000000'}
                  onChangeComplete={(color) => handleColorChange('primaryColor', color)}
                  disableAlpha={false}
                />
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-sm-3 col-6">
            <div className="form-group">
              <label htmlFor="secondaryColor">Secondary Color</label>
              <div style={{ overflow: 'auto' }}>
                <SketchPicker
                  color={settings.find((s) => s.type === 'secondaryColor')?.value || '#ffffff'}
                  onChangeComplete={(color) => handleColorChange('secondaryColor', color)}
                  disableAlpha={false}
                />
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-sm-3 col-6">
            <div className="form-group">
              <label htmlFor="headerColor">Header Color</label>
              <div style={{ overflow: 'auto' }}>
                <SketchPicker
                  color={settings.find((s) => s.type === 'headerColor')?.value || '#ffffff'}
                  onChangeComplete={(color) => handleColorChange('headerColor', color)}
                  disableAlpha={false}
                />
              </div>
            </div>
          </div>
          <div className="col-xl-6 col-sm-6 col-12">
            <div className="form-group">
              <label htmlFor="fontFamily">Font Family</label>
              <input
                type="text"
                id="fontFamily"
                className="form-control"
                placeholder="Enter font family"
                value={settings.find((s) => s.type === 'fontFamily')?.value || ''}
                onChange={(e) => handleInputChange('fontFamily', e.target.value)}
              />
            </div>
          </div>
          <div className="col-xl-12 col-sm-12 col-12" style={{ textAlign: 'right' }}>
            <button
              type="submit"
              className="btn btn-primary"
              style={{ marginBottom: '10px', padding: '13px' }}
              onClick={handleSubmit}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
